// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PAd9z","label":"styles_label__3kaHy"};